import { render, staticRenderFns } from "./AccDeleteModal.vue?vue&type=template&id=67604116"
import script from "./AccDeleteModal.vue?vue&type=script&lang=js"
export * from "./AccDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports